import React, { Component } from 'react'
import {Link} from 'react-router-dom';
import { handleSearchMovieDetail, handleSearchMovie } from '../actions'

export default class SearchCard extends Component {
    render() {
        const {data} = this.props;
        const detailsHandle = ()=>{
            const {dispatch} =this.props;
            console.log('search Card');
            console.log(data);
            // dispatch(addMovieBack(data.backdrop_path));
            // dispatch(handleMovieDetails(data.Title));
            // // dispatch(handleMoreMovies(data.original_language,data.genre_ids[0]));
            if(data.Type=='movie'){
            dispatch(handleSearchMovieDetail(data.imdbID,data.Type));
            dispatch(handleSearchMovie(data.imdbID));
            }
            if(data.Type=='series'){
            dispatch(handleSearchMovieDetail(data.imdbID,data.Type));
            dispatch(handleSearchMovie(data.imdbID));
            }
            window.scrollTo({
                top: 0,
                behavior: "smooth"
              });
         }
        return (
            <Link style={{textDecoration:'none'}} to="/movie-details">
            <div onClick={detailsHandle} className="search-card"  style={{backgroundImage:`url('${data.Poster}')`}}>
                 <div className="search-card-details">
                 <div className="search-detail">
                    <p className="search-card-title">{data.Title}</p>
                    <p className="search-card-type">{data.Type}</p>
                    <span className="detail"><span>{data.Year}</span>{data.adult&&<span>18+</span>}{!data.adult&&<span className="line">18+</span>}<span>{data.imdbID}</span><span className="last">Action</span></span>
                    <p className="movie-detail">{data.overview}</p>
                 </div>
                 </div>
            </div>
            </Link>
        )
    }
}
